module.exports = __webpack_public_path__ + "img/16_55.81e120a5.png";